var map = {
	"./APP_icon.svg": "./src/assets/icons/svg/APP_icon.svg",
	"./EquipmentCenter.svg": "./src/assets/icons/svg/EquipmentCenter.svg",
	"./IDCardBack.svg": "./src/assets/icons/svg/IDCardBack.svg",
	"./IDCardJust.svg": "./src/assets/icons/svg/IDCardJust.svg",
	"./NoRelevantDataYet.svg": "./src/assets/icons/svg/NoRelevantDataYet.svg",
	"./Steve-Jobs.svg": "./src/assets/icons/svg/Steve-Jobs.svg",
	"./VehiclesTotal.svg": "./src/assets/icons/svg/VehiclesTotal.svg",
	"./Visitor_icon.svg": "./src/assets/icons/svg/Visitor_icon.svg",
	"./alarmClock.svg": "./src/assets/icons/svg/alarmClock.svg",
	"./alipay.svg": "./src/assets/icons/svg/alipay.svg",
	"./anq.svg": "./src/assets/icons/svg/anq.svg",
	"./app.svg": "./src/assets/icons/svg/app.svg",
	"./assets_icon.svg": "./src/assets/icons/svg/assets_icon.svg",
	"./backup.svg": "./src/assets/icons/svg/backup.svg",
	"./bell.svg": "./src/assets/icons/svg/bell.svg",
	"./blink.svg": "./src/assets/icons/svg/blink.svg",
	"./calendar.svg": "./src/assets/icons/svg/calendar.svg",
	"./camera.svg": "./src/assets/icons/svg/camera.svg",
	"./chain.svg": "./src/assets/icons/svg/chain.svg",
	"./chart.svg": "./src/assets/icons/svg/chart.svg",
	"./close.svg": "./src/assets/icons/svg/close.svg",
	"./closedEyes.svg": "./src/assets/icons/svg/closedEyes.svg",
	"./codeConsole.svg": "./src/assets/icons/svg/codeConsole.svg",
	"./correct.svg": "./src/assets/icons/svg/correct.svg",
	"./current_icon.svg": "./src/assets/icons/svg/current_icon.svg",
	"./dashboard.svg": "./src/assets/icons/svg/dashboard.svg",
	"./database.svg": "./src/assets/icons/svg/database.svg",
	"./date.svg": "./src/assets/icons/svg/date.svg",
	"./deploy.svg": "./src/assets/icons/svg/deploy.svg",
	"./dept.svg": "./src/assets/icons/svg/dept.svg",
	"./dev.svg": "./src/assets/icons/svg/dev.svg",
	"./develop.svg": "./src/assets/icons/svg/develop.svg",
	"./dictionary.svg": "./src/assets/icons/svg/dictionary.svg",
	"./doc.svg": "./src/assets/icons/svg/doc.svg",
	"./download.svg": "./src/assets/icons/svg/download.svg",
	"./edit.svg": "./src/assets/icons/svg/edit.svg",
	"./education.svg": "./src/assets/icons/svg/education.svg",
	"./email.svg": "./src/assets/icons/svg/email.svg",
	"./empower_icon.svg": "./src/assets/icons/svg/empower_icon.svg",
	"./equipment.svg": "./src/assets/icons/svg/equipment.svg",
	"./equipment_icon.svg": "./src/assets/icons/svg/equipment_icon.svg",
	"./error.svg": "./src/assets/icons/svg/error.svg",
	"./estate_icon.svg": "./src/assets/icons/svg/estate_icon.svg",
	"./exit-fullscreen.svg": "./src/assets/icons/svg/exit-fullscreen.svg",
	"./exit-video-fullscreen.svg": "./src/assets/icons/svg/exit-video-fullscreen.svg",
	"./fullscreen.svg": "./src/assets/icons/svg/fullscreen.svg",
	"./fwb.svg": "./src/assets/icons/svg/fwb.svg",
	"./github.svg": "./src/assets/icons/svg/github.svg",
	"./gonggao.svg": "./src/assets/icons/svg/gonggao.svg",
	"./homeHouses.svg": "./src/assets/icons/svg/homeHouses.svg",
	"./home_1.svg": "./src/assets/icons/svg/home_1.svg",
	"./home_2.svg": "./src/assets/icons/svg/home_2.svg",
	"./households.svg": "./src/assets/icons/svg/households.svg",
	"./housingManagement.svg": "./src/assets/icons/svg/housingManagement.svg",
	"./icon.svg": "./src/assets/icons/svg/icon.svg",
	"./image.svg": "./src/assets/icons/svg/image.svg",
	"./imgs.svg": "./src/assets/icons/svg/imgs.svg",
	"./index.svg": "./src/assets/icons/svg/index.svg",
	"./information_icon.svg": "./src/assets/icons/svg/information_icon.svg",
	"./international.svg": "./src/assets/icons/svg/international.svg",
	"./ipvisits.svg": "./src/assets/icons/svg/ipvisits.svg",
	"./java.svg": "./src/assets/icons/svg/java.svg",
	"./link.svg": "./src/assets/icons/svg/link.svg",
	"./list.svg": "./src/assets/icons/svg/list.svg",
	"./lock.svg": "./src/assets/icons/svg/lock.svg",
	"./log.svg": "./src/assets/icons/svg/log.svg",
	"./login.svg": "./src/assets/icons/svg/login.svg",
	"./logoComplete.svg": "./src/assets/icons/svg/logoComplete.svg",
	"./maintenance_icon.svg": "./src/assets/icons/svg/maintenance_icon.svg",
	"./markdown.svg": "./src/assets/icons/svg/markdown.svg",
	"./menu.svg": "./src/assets/icons/svg/menu.svg",
	"./message.svg": "./src/assets/icons/svg/message.svg",
	"./message_icon.svg": "./src/assets/icons/svg/message_icon.svg",
	"./miehuoqi.svg": "./src/assets/icons/svg/miehuoqi.svg",
	"./mnt.svg": "./src/assets/icons/svg/mnt.svg",
	"./money.svg": "./src/assets/icons/svg/money.svg",
	"./monitor.svg": "./src/assets/icons/svg/monitor.svg",
	"./monitor_icon.svg": "./src/assets/icons/svg/monitor_icon.svg",
	"./monitoring.svg": "./src/assets/icons/svg/monitoring.svg",
	"./nested.svg": "./src/assets/icons/svg/nested.svg",
	"./no-view.svg": "./src/assets/icons/svg/no-view.svg",
	"./password.svg": "./src/assets/icons/svg/password.svg",
	"./people.svg": "./src/assets/icons/svg/people.svg",
	"./peopleDataViewBoard.svg": "./src/assets/icons/svg/peopleDataViewBoard.svg",
	"./peoples.svg": "./src/assets/icons/svg/peoples.svg",
	"./permission.svg": "./src/assets/icons/svg/permission.svg",
	"./personnel_icon.svg": "./src/assets/icons/svg/personnel_icon.svg",
	"./phone.svg": "./src/assets/icons/svg/phone.svg",
	"./platformUser.svg": "./src/assets/icons/svg/platformUser.svg",
	"./qiniu.svg": "./src/assets/icons/svg/qiniu.svg",
	"./record.svg": "./src/assets/icons/svg/record.svg",
	"./redis.svg": "./src/assets/icons/svg/redis.svg",
	"./returnSvg.svg": "./src/assets/icons/svg/returnSvg.svg",
	"./role.svg": "./src/assets/icons/svg/role.svg",
	"./search.svg": "./src/assets/icons/svg/search.svg",
	"./server.svg": "./src/assets/icons/svg/server.svg",
	"./shield.svg": "./src/assets/icons/svg/shield.svg",
	"./shopping.svg": "./src/assets/icons/svg/shopping.svg",
	"./signOut.svg": "./src/assets/icons/svg/signOut.svg",
	"./size.svg": "./src/assets/icons/svg/size.svg",
	"./skill.svg": "./src/assets/icons/svg/skill.svg",
	"./source.svg": "./src/assets/icons/svg/source.svg",
	"./sqlMonitor.svg": "./src/assets/icons/svg/sqlMonitor.svg",
	"./swagger.svg": "./src/assets/icons/svg/swagger.svg",
	"./sys-tools.svg": "./src/assets/icons/svg/sys-tools.svg",
	"./system.svg": "./src/assets/icons/svg/system.svg",
	"./system1.svg": "./src/assets/icons/svg/system1.svg",
	"./system_icon.svg": "./src/assets/icons/svg/system_icon.svg",
	"./tab.svg": "./src/assets/icons/svg/tab.svg",
	"./theme.svg": "./src/assets/icons/svg/theme.svg",
	"./timing.svg": "./src/assets/icons/svg/timing.svg",
	"./tools.svg": "./src/assets/icons/svg/tools.svg",
	"./tree-table.svg": "./src/assets/icons/svg/tree-table.svg",
	"./tree.svg": "./src/assets/icons/svg/tree.svg",
	"./unlock.svg": "./src/assets/icons/svg/unlock.svg",
	"./user.svg": "./src/assets/icons/svg/user.svg",
	"./user1.svg": "./src/assets/icons/svg/user1.svg",
	"./users.svg": "./src/assets/icons/svg/users.svg",
	"./users_1.svg": "./src/assets/icons/svg/users_1.svg",
	"./validCode.svg": "./src/assets/icons/svg/validCode.svg",
	"./vehicleDataViewBoard.svg": "./src/assets/icons/svg/vehicleDataViewBoard.svg",
	"./video-fullscreen.svg": "./src/assets/icons/svg/video-fullscreen.svg",
	"./view.svg": "./src/assets/icons/svg/view.svg",
	"./visitor.svg": "./src/assets/icons/svg/visitor.svg",
	"./visits.svg": "./src/assets/icons/svg/visits.svg",
	"./web.svg": "./src/assets/icons/svg/web.svg",
	"./wechat.svg": "./src/assets/icons/svg/wechat.svg",
	"./weixin.svg": "./src/assets/icons/svg/weixin.svg",
	"./zujian.svg": "./src/assets/icons/svg/zujian.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";